<div class="main-content">
    <app-navbar></app-navbar>
    <div class="content-section main-section clearfix">
        <app-side-menu></app-side-menu>
        <div class="content-body">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
